module.exports = __webpack_public_path__ + "static/media/4-4.4de1fab2.mp3";